<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="提现单号">
                <a-input v-model="queryParam.withdrawalNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.phone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="姓名">
                <a-input v-model="queryParam.nameA" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="提现账户">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalAccount" style="width: 100%" allow-clear>
                  <a-select-option :value="0">余额</a-select-option>
                  <a-select-option :value="1">押金</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="提现类型">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalType" style="width: 100%" allow-clear>
                  <a-select-option :value="0">支付宝</a-select-option>
                  <a-select-option :value="1">微信</a-select-option>
                  <a-select-option :value="2">银行卡</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalState" style="width: 100%" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">审核通过</a-select-option>
                  <a-select-option :value="2">审核失败</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否已审核">
                <a-select placeholder="请选择" v-model="queryParam.checkedAud" style="width: 100%" allow-clear>
                  <a-select-option :value="0">未审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="createTimeValue"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeCreateTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="处理时间">
                <a-range-picker
                  v-model="examineTimeValue"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeExamineTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 18" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="withdrawalType" slot-scope="text, record">
          <a-tag :color="getWithdrawalTypeColor(record.withdrawalType)">
            {{ getWithdrawalTypeText(record.withdrawalType) }}
          </a-tag>
        </span>
        <span slot="withdrawalAccount" slot-scope="text, record">
          <a-tag :color="record.withdrawalAccount === 0 ? 'blue' : 'green'">
            {{ record.withdrawalAccount === 0 ? '余额' : '押金' }}
          </a-tag>
        </span>
        <span slot="withdrawalState" slot-scope="text, record">
          <a-tag :color="getWithdrawalStateColor(record.withdrawalState)">
            {{ getWithdrawalStateText(record.withdrawalState) }}
          </a-tag>
        </span>
        <span slot="withdrawalMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="withdrawalFrontMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="withdrawalAfterMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="fee" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="withdrawalNo" slot-scope="text, record">
          <a-tooltip :title="record.withdrawalNo || '--'">
            <span class="text-ellipsis">{{ record.withdrawalNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="phone" slot-scope="text, record">
          <a-tooltip :title="record.phone || '--'">
            <span class="text-ellipsis">{{ record.phone || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="name" slot-scope="text, record">
          {{ (record.surname || '') + (record.name || '') || '--' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip :title="record.createTime || '--'">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchWithdrawalList } from '@/api/pressure/fund'
import moment from 'moment'

export default {
  name: 'FundWithdrawal',
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        withdrawalNo: undefined,
        phone: undefined,
        nameA: undefined,
        withdrawalAccount: undefined,
        withdrawalType: undefined,
        withdrawalState: undefined,
        checkedAud: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        withdrawalExamineTimeStart: undefined,
        withdrawalExamineTimeEnd: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      total: 0,
      createTimeValue: [],
      examineTimeValue: [],
      advanced: false,
      loading: false,
      tableSize: 'default',
      columns: [
        {
          title: '提现单号',
          dataIndex: 'withdrawalNo',
          key: 'withdrawalNo',
          scopedSlots: { customRender: 'withdrawalNo' },
          align: 'center',
          width: 180,
        },
        {
          title: '用户手机号',
          dataIndex: 'phone',
          key: 'phone',
          scopedSlots: { customRender: 'phone' },
          align: 'center',
          width: 120,
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现类型',
          dataIndex: 'withdrawalType',
          key: 'withdrawalType',
          scopedSlots: { customRender: 'withdrawalType' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现账户',
          dataIndex: 'withdrawalAccount',
          key: 'withdrawalAccount',
          scopedSlots: { customRender: 'withdrawalAccount' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现金额',
          dataIndex: 'withdrawalMoney',
          key: 'withdrawalMoney',
          scopedSlots: { customRender: 'withdrawalMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '手续费',
          dataIndex: 'fee',
          key: 'fee',
          scopedSlots: { customRender: 'fee' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现前金额',
          dataIndex: 'withdrawalFrontMoney',
          key: 'withdrawalFrontMoney',
          scopedSlots: { customRender: 'withdrawalFrontMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '提现后金额',
          dataIndex: 'withdrawalAfterMoney',
          key: 'withdrawalAfterMoney',
          scopedSlots: { customRender: 'withdrawalAfterMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '审核状态',
          dataIndex: 'withdrawalState',
          key: 'withdrawalState',
          scopedSlots: { customRender: 'withdrawalState' },
          align: 'center',
          width: 100,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 180,
        },
      ],
    }
  },
  methods: {
    getWithdrawalTypeText(type) {
      const map = {
        0: '支付宝',
        1: '微信',
        2: '银行卡',
      }
      return map[type] || '未知'
    },
    getWithdrawalTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'gray'
    },
    getWithdrawalStateText(state) {
      const map = {
        0: '待审核',
        1: '审核通过',
        2: '审核失败',
      }
      return map[state] || '未知'
    },
    getWithdrawalStateColor(state) {
      const map = {
        0: 'orange',
        1: 'green',
        2: 'red',
      }
      return map[state] || 'gray'
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        withdrawalNo: undefined,
        phone: undefined,
        nameA: undefined,
        withdrawalAccount: undefined,
        withdrawalType: undefined,
        withdrawalState: undefined,
        checkedAud: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        withdrawalExamineTimeStart: undefined,
        withdrawalExamineTimeEnd: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.createTimeValue = []
      this.examineTimeValue = []
      this.handleQuery()
    },
    getList() {
      this.loading = true
      fetchWithdrawalList(this.queryParam)
        .then((res) => {
          this.list = res.data.records || []
          this.total = res.data.total || 0
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onChangeCreateTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onChangeExamineTime(e) {
      if (e && e.length === 2) {
        this.queryParam.withdrawalExamineTimeStart = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.withdrawalExamineTimeEnd = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.withdrawalExamineTimeStart = undefined
        this.queryParam.withdrawalExamineTimeEnd = undefined
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
